import * as Yup from 'yup'

export const schema = Yup.object().shape({
  arquivo: Yup.string().required('Deve selecionar um arquivo')
})
